import { RosterUpgradesAndWins } from '@wwe-portal/ui/features/roster/roster-upgrades-and-wins';
import { useSuperstarDetailContext } from './context';
import { useMemo } from 'react';

const sum = (arr: number[]) => {
  return arr.reduce((acc, curr) => acc + curr, 0);
};

export const UpgradesAndWinsConsumer = () => {
  const statsSheet = useSuperstarDetailContext((state) => state.statsSheet);
  const props = useMemo(() => {
    const last30Days = statsSheet.progression.slice(-1)[0];
    const allTimeWins = sum(
      statsSheet.progression.map((item) => Number(item.wins))
    );
    const allTimeUpgrades = sum(
      statsSheet.progression.map((item) => Number(item.talent_upgrade))
    );
    return {
      upgrades: {
        last30days: last30Days?.talent_upgrade,
        allTime: allTimeUpgrades.toString(),
      },
      wins: {
        last30days: last30Days?.wins,
        allTime: allTimeWins.toString(),
      },
    };
  }, [statsSheet]);
  return <RosterUpgradesAndWins {...props} />;
};
